import cx from 'classnames';
import React from 'react';
import { useRobotSelector } from '../context';
import RobotFieldBg from '../__field/robot__field-bg';
import RobotField from '../__field/robot__field';
import RobotSampleSwitch from '../__sample-switch/robot__sample-switch';
import { RobotOpenSandboxButton } from '../__open-sandbox-button/robot__open-sandbox-button';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot__field-pane.module.scss';

export const RobotFieldPane = ({
    withSandbox,
    shouldShowV2Interface,
    className,
}: {
    withSandbox?: boolean;
    shouldShowV2Interface?: boolean;
    className?: string;
}) => {
    const teacherMode = useRobotSelector((store) => store.teacherMode);
    return shouldShowV2Interface ? (
        <RobotFieldBg
            className={cx(styles.left_v2, { [styles.left_teacher]: teacherMode }, 'qa_robot-field', className)}
        >
            <RobotField />
        </RobotFieldBg>
    ) : (
        <RobotFieldBg className={cx(styles.left, { [styles.left_teacher]: teacherMode }, 'qa_robot-field', className)}>
            <div
                className={cx(
                    styles.sample_switch,
                    { [styles.sample_switch_teacher]: teacherMode },
                    'qa_robot-sample-switch'
                )}
            >
                <RobotSampleSwitch />
            </div>
            <RobotField />
            {withSandbox && <RobotOpenSandboxButton />}
        </RobotFieldBg>
    );
};
